import { render, staticRenderFns } from "./SimulatorPanel.vue?vue&type=template&id=48405542&scoped=true&"
import script from "./SimulatorPanel.vue?vue&type=script&lang=js&"
export * from "./SimulatorPanel.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPanel.vue?vue&type=style&index=0&id=48405542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48405542",
  null
  
)

export default component.exports